import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import React, { useEffect, useState, FormEvent } from "react";
import { defaultLocation } from "components/Map/map";
import { defaultLocationType } from "components/Map/map";
import { ValidationErrorMessages } from "utils/Error";
import { notify, ToastType } from "utils/Toast";
import { useDispatch } from "react-redux";
import { setBlurAction } from "ReduxSaga/actions/GeneralActions";

interface Props {
  Component: any;
}

const BaseInfo: React.FC<Props> = ({ Component }) => {
  const [typeEdit, setTypeEdit] = useState<boolean>(false);
  const [typeAdd, setTypeAdd] = useState<boolean>(false);
  const [items, setItems] = useState<any>([]);
  const [selectedSectionId, setSelectedSectionId] = useState<number | null>();
  const [faNameEdit, setFaNameEdit] = useState<string>("");
  const [engNameEdit, setEngNameEdit] = useState<string>("");
  const [errorFaNameEdit, setErrorFaNameEdit] = useState<string | null>(null);
  const [errorEngNameEdit, setErrorEngNameEdit] = useState<string | null>(null);
  const [faNameAdd, setFaNameAdd] = useState<string>("");
  const [engNameAdd, setEngNameAdd] = useState<string>("");
  const [errorFaNameAdd, setErrorFaNameAdd] = useState<string | null>(null);
  const [errorEngNameAdd, setErrorEngNameAdd] = useState<string | null>(null);
  const [location, setLocation] =
    useState<defaultLocationType>(defaultLocation);
  const [showErrors, setShowErrors] = useState<boolean>(false);
  const [allowToAdd, setAllowToAdd] = useState<boolean>(true);
  const [regionData, setRegionData] = useState<any>([]);
  const [selectedRegionId, setSelectedRegionId] = useState<string>("");
  const [showEditRegionData, setShowEditRegionData] = useState<boolean>(false);
  const [newItem, setNewItem] = useState<string>("");
  const [errorNewItem, setErrorNewItem] = useState<string | null>(null);
  const [showAddInput, setShowAddInput] = useState<boolean>(true);
  const [facilityData, setFacilityData] = useState<any>([]);
  const [floorCoverData, setFloorCoverData] = useState<any>([]);
  const [kitchenServiceData, setKitchenServiceData] = useState<any>([]);
  const [PropertyData, setPropertyData] = useState<any>([]);
  const [existingItems, setExistingItems] = useState<any>([]);
  const [selectedItemForEditId, setSelectedItemForEditId] =
    useState<string>("");
  const [editItem, setEditItem] = useState<string>("");
  const [errorEditItem, setErrorEditItem] = useState<string | null>(null);
  const [showEditInput, setShowEditInput] = useState<boolean>(true);
  const [mapZoom, setMapZoom] = useState<string>('');
  const dispatch = useDispatch();
  
  const sections = [
    { id: 0, title: "Region" },
    { id: 1, title: "Floor Cover" },
    { id: 2, title: "Kitchen Service" },
    { id: 3, title: "Facility" },
    { id: 4, title: "Property" },
  ];

  useEffect(() => {
    setItems(sections);
    reNewRegionData();
    reNewAllDataExeptRegion();
  }, []);

  const reNewRegionData = () => {
    Axios(AxiosMethodEnum.get, Axios_Route.REGION_LIST).then(
      ({ response, success }) => {
        if (success) {
          setRegionData(response);
        }
      }
    );
  };

  function reNewAllDataExeptRegion() {
    Axios(AxiosMethodEnum.get, Axios_Route.FACILITY_LIST).then(
      ({ response, success }) => {
        if (success) {
          setFacilityData(response);
        }
      }
    );

    Axios(AxiosMethodEnum.get, Axios_Route.BASE_INFO + "?ParentId=40").then(
      ({ response, success }) => {
        if (success) {
          setFloorCoverData(response);
        }
      }
    );

    Axios(AxiosMethodEnum.get, Axios_Route.BASE_INFO + "?ParentId=30").then(
      ({ response, success }) => {
        if (success) {
          setKitchenServiceData(response);
        }
      }
    );

    Axios(AxiosMethodEnum.get, Axios_Route.BASE_INFO + "?ParentId=10").then(
      ({ response, success }) => {
        if (success) {
          setPropertyData(response);
        }
      }
    );
  }

  useEffect(() => {
    if (typeEdit) {
      setTypeAdd(false);
    }
  }, [typeEdit]);

  useEffect(() => {
    if (typeAdd) {
      setTypeEdit(false);
    }
  }, [typeAdd]);

  const resetPage = () => {
    setFaNameEdit("");
    setEngNameEdit("");
    setErrorFaNameEdit(null);
    setErrorEngNameEdit(null);
    setFaNameAdd("");
    setEngNameAdd("");
    setErrorFaNameAdd(null);
    setErrorEngNameAdd(null);
    setLocation(defaultLocation);
    setShowErrors(false);
    setAllowToAdd(true);
    setSelectedRegionId("");
    setNewItem("");
    setErrorNewItem(null);
    setShowAddInput(false);
    setSelectedItemForEditId("");
    setEditItem("");
    setMapZoom('')
    setErrorEditItem(null);
    setShowEditInput(false);
    switch (selectedSectionId) {
      // FLOOR COVER
      case 1:
        setExistingItems(floorCoverData);
        break;

      // KITCHEN SERVICE
      case 2:
        setExistingItems(kitchenServiceData);
        break;

      // FACILITY
      case 3:
        setExistingItems(facilityData);
        break;

      // PROPERTY
      case 4:
        setExistingItems(PropertyData);
        break;
    }
    setTimeout(() => {
      setShowAddInput(true);
      setShowEditInput(true);
    }, 10);
  };

  useEffect(() => {
    resetPage();
  }, [typeEdit, typeAdd, selectedSectionId]);

  useEffect(() => {
    const selectedObj = existingItems.find(
      (item: any) => item.id === selectedItemForEditId
    );
    if (selectedObj !== undefined) {
      setShowEditInput(false);
      setEditItem(selectedObj.title);
      setTimeout(() => {
        setShowEditInput(true);
      }, 1);
    }
  }, [selectedItemForEditId]);

  useEffect(() => {
    setShowEditRegionData(false);
    if (regionData.length > 0 && selectedRegionId !== '') {
      Axios(
        AxiosMethodEnum.get,
        Axios_Route.EDIT_REGION + "?regionId=%20" + selectedRegionId
      ).then(({ response, success }) => {
        if (success) {
          setFaNameEdit(response[0].persianName);
          setEngNameEdit(response[0].title);
          setLocation({
            lat: response[0].latitude,
            lng: response[0].longitude,
          });
          setMapZoom(response[0].mapZoom);
          setShowEditRegionData(true);
        }
      });
    }
  }, [selectedRegionId]);

  const errorHandlingAddRegion = () => {
    let AllowToContinue = true;

    if (faNameAdd.length === 0) {
      setErrorFaNameAdd(ValidationErrorMessages.ERRORS.FIELD_REQUIRED);
      AllowToContinue = false;
    } else {
      setErrorFaNameAdd(null);
    }

    if (engNameAdd.length === 0) {
      setErrorEngNameAdd(ValidationErrorMessages.ERRORS.FIELD_REQUIRED);
      AllowToContinue = false;
    } else {
      setErrorEngNameAdd(null);
    }

    return AllowToContinue;
  };

  const addRegionFunc = (e: FormEvent) => {
    e.preventDefault();

    setShowErrors(true);
    let AllowToContinue = errorHandlingAddRegion();

    if (!AllowToContinue) {
      window.scrollTo({ top: 0 });
    }

    const RegionObjAdd = {
      latitude: location.lat,
      longitude: location.lng,
      persianName: faNameAdd,
      title: engNameAdd,
    };

    if (AllowToContinue && allowToAdd) {
      setAllowToAdd(false);

      Axios(AxiosMethodEnum.post, Axios_Route.Add_REGION, RegionObjAdd).then(
        ({ response, success }) => {
          setAllowToAdd(true);
          if (success) {
            const SelectedId = selectedSectionId;
            setSelectedSectionId(undefined);
            reNewRegionData();
            dispatch(setBlurAction(true));
            setTimeout(() => {
              setSelectedSectionId(SelectedId);
              dispatch(setBlurAction(false));
              resetPage();
            }, 1000);
            notify(
              ValidationErrorMessages.SUCCESS.REGION_ADDED,
              ToastType.success
            );
          } else if (!success) {
            notify(response.message, ToastType.error);
          }
        }
      );
    }
  };

  const errorHandlingEditRegion = () => {
    let AllowToContinue = true;

    if (faNameEdit.length === 0) {
      setErrorFaNameEdit(ValidationErrorMessages.ERRORS.FIELD_REQUIRED);
      AllowToContinue = false;
    } else {
      setErrorFaNameEdit(null);
    }

    if (engNameEdit.length === 0) {
      setErrorEngNameEdit(ValidationErrorMessages.ERRORS.FIELD_REQUIRED);
      AllowToContinue = false;
    } else {
      setErrorEngNameEdit(null);
    }

    return AllowToContinue;
  };

  const editRegionFunc = (e: FormEvent) => {
    e.preventDefault();

    setShowErrors(true);
    let AllowToContinue = errorHandlingEditRegion();

    if (!AllowToContinue) {
      window.scrollTo({ top: 0 });
    }

    const RegionObjEdit = {
      id: selectedRegionId,
      latitude: location.lat,
      longitude: location.lng,
      persianName: faNameEdit,
      title: engNameEdit,
      orderId: regionData.find((item: any) => item.id === selectedRegionId)
        .orderId,
      mapZoom:mapZoom,
    };
    
    if (AllowToContinue && allowToAdd) {
      setAllowToAdd(false);
      Axios(AxiosMethodEnum.post, Axios_Route.EDIT_REGION, RegionObjEdit).then(
        ({ response, success }) => {
          setAllowToAdd(true);
          if (success) {
            reNewRegionData();
            dispatch(setBlurAction(true));
            setTimeout(() => {
              dispatch(setBlurAction(false));
              resetPage();
            }, 1000);
            notify(
              ValidationErrorMessages.SUCCESS.REGION_EDITED,
              ToastType.success
            );
          } else if (!success) {
            notify(response.message, ToastType.error);
          }
        }
      );
    }
  };

  const AddItemErrorHandling = () => {
    if (newItem.length === 0) {
      setErrorNewItem(ValidationErrorMessages.ERRORS.FIELD_REQUIRED);
      window.scrollTo({ top: 0 });
    } else {
      setErrorNewItem(null);
    }
  };

  useEffect(() => {
    if (showErrors) {
      AddItemErrorHandling();
    }
  }, [newItem]);

  const addItemFunc = (e: FormEvent) => {
    e.preventDefault();

    setShowErrors(true);
    AddItemErrorHandling();

    let url = "";
    let ItemObjAdd = {};
    if (selectedSectionId === 3) {
      url = Axios_Route.FACILITY_ADD;
      ItemObjAdd = {
        check: false,
        title: newItem,
      };
    } else {
      url = Axios_Route.BASE_INFO_ADD;
      let parentId;
      switch (selectedSectionId) {
        // FLOOR COVER
        case 1:
          parentId = 40;
          break;

        // KITCHEN SERVICE
        case 2:
          parentId = 30;
          break;

        // PROPERTY
        case 4:
          parentId = 10;
          break;
      }
      ItemObjAdd = {
        parent_id: parentId,
        title: newItem,
        displayTitle: newItem,
        isActive: true,
        isDisplay: true,
      };
    }

    if (errorNewItem === null && allowToAdd) {
      setAllowToAdd(false);
      Axios(AxiosMethodEnum.post, url, ItemObjAdd).then(
        ({ response, success }) => {
          setAllowToAdd(true);
          if (success) {
            const SelectedId = selectedSectionId;
            setSelectedSectionId(undefined);
            reNewAllDataExeptRegion();
            dispatch(setBlurAction(true));
            setTimeout(() => {
              setSelectedSectionId(SelectedId);
              dispatch(setBlurAction(false));
              resetPage();
            }, 1000);
            notify(
              ValidationErrorMessages.SUCCESS.NEW_ITEM_ADDED,
              ToastType.success
            );
          } else if (!success) {
            notify(response.message, ToastType.error);
          }
        }
      );
    }
  };

  const EditItemErrorHandling = () => {
    if (editItem.length === 0) {
      setErrorEditItem(ValidationErrorMessages.ERRORS.FIELD_REQUIRED);
      window.scrollTo({ top: 0 });
    } else {
      setErrorEditItem(null);
    }
  };

  useEffect(() => {
    if (showErrors) {
      EditItemErrorHandling();
    }
  }, [editItem]);

  const editItemFunc = (e: FormEvent) => {
    e.preventDefault();

    setShowErrors(true);
    EditItemErrorHandling();

    let url = "";
    let ItemObjEdit = {};
    if (selectedSectionId === 3) {
      url = Axios_Route.FACILITY_EDIT;
      ItemObjEdit = {
        check: false,
        title: editItem,
        id: selectedItemForEditId,
      };
    } else {
      url = Axios_Route.BASE_EDIT;
      ItemObjEdit = {
        id: selectedItemForEditId,
        title: editItem,
      };
    }

    if (errorEditItem === null && allowToAdd) {
      setAllowToAdd(false);
      Axios(AxiosMethodEnum.post, url, ItemObjEdit).then(
        ({ response, success }) => {
          setAllowToAdd(true);
          if (success) {
            const SelectedId = selectedSectionId;
            setSelectedSectionId(undefined);
            reNewAllDataExeptRegion();
            dispatch(setBlurAction(true));
            setTimeout(() => {
              setSelectedSectionId(SelectedId);
              dispatch(setBlurAction(false));
              resetPage();
            }, 1000);
            notify(
              ValidationErrorMessages.SUCCESS.NEW_ITEM_EDITED,
              ToastType.success
            );
          } else if (!success) {
            notify(response.message, ToastType.error);
          }
        }
      );
    }
  };

  return (
    <div>
      <Component
        typeEdit={typeEdit}
        setTypeEdit={setTypeEdit}
        typeAdd={typeAdd}
        setTypeAdd={setTypeAdd}
        setSelectedSectionId={setSelectedSectionId}
        items={items}
        selectedSectionId={selectedSectionId}
        faNameEdit={faNameEdit}
        setFaNameEdit={setFaNameEdit}
        engNameEdit={engNameEdit}
        setEngNameEdit={setEngNameEdit}
        errorFaNameEdit={errorFaNameEdit}
        errorEngNameEdit={errorEngNameEdit}
        faNameAdd={faNameAdd}
        setFaNameAdd={setFaNameAdd}
        engNameAdd={engNameAdd}
        setEngNameAdd={setEngNameAdd}
        errorFaNameAdd={errorFaNameAdd}
        errorEngNameAdd={errorEngNameAdd}
        location={location}
        setLocation={setLocation}
        addRegionFunc={addRegionFunc}
        regionData={regionData}
        setSelectedRegionId={setSelectedRegionId}
        showEditRegionData={showEditRegionData}
        editRegionFunc={editRegionFunc}
        newItem={newItem}
        setNewItem={setNewItem}
        errorNewItem={errorNewItem}
        showAddInput={showAddInput}
        addItemFunc={addItemFunc}
        existingItems={existingItems}
        setSelectedItemForEditId={setSelectedItemForEditId}
        editItem={editItem}
        setEditItem={setEditItem}
        errorEditItem={errorEditItem}
        editItemFunc={editItemFunc}
        showEditInput={showEditInput}
      />
    </div>
  );
};

export default BaseInfo;
